import { createFileRoute } from "@tanstack/react-router";

/**
 * Không gian làm việc một đơn hậu kỳ (QĐ 0368, mẫu T2/T3).
 *
 * `?asset=` mở sẵn popup của một tấm, `?note=` cuộn tới ghi chú đó trong khối
 * "Ghi chú của tấm" — chuông @nhắc của ghi chú theo ảnh mở tới đây (QĐ 0438).
 * Giá trị lạ được tha: tấm không có trong đơn thì màn mở như thường.
 */
export type RetouchOrderSearch = { asset?: string | undefined; note?: string | undefined };

export const Route = createFileRoute("/_app/retouch/orders/$orderId")({
  validateSearch: (search: Record<string, unknown>): RetouchOrderSearch => ({
    asset: typeof search.asset === "string" ? search.asset : undefined,
    note: typeof search.note === "string" ? search.note : undefined,
  }),
});
